module.exports = __webpack_public_path__ + "static/media/bg.05dbae57.png";


//////////////////
// WEBPACK FOOTER
// ./src/customerServiceCenter/images/bg.png
// module id = 1056
// module chunks = 0